import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => ({
      title: formatMessage(messages.title),
    }),
    [formatMessage],
  );
};

export default useTranslations;
